'use strict';

PopoverSelectContainerDirective.$inject = [];

export function PopoverSelectContainerDirective() {
  return {
    restrict: 'A',
    controller: PopoverSelectContainerController,
    compile: function ($element, attr) {
      return function ngEventHandler(scope, element, attrs, ctrl) {
        element.on('click', event => {
          if (ctrl.selectCtrl) {
            event.preventDefault();
            event.stopPropagation();
            scope.$apply(() => {
              ctrl.selectCtrl.showOptions(event);
            });
          }
        });

        scope.$on('$destroy', cleanup);

        function cleanup() {
          ctrl.unregister();
        }
      };
    },
  };
}

function PopoverSelectContainerController() {
  this.selectCtrl = null;
}

PopoverSelectContainerController.prototype.register = register;
PopoverSelectContainerController.prototype.unregister = unregister;

function register(selector) {
  this.selectCtrl = selector;
}

function unregister() {
  this.selectCtrl = null;
}



// WEBPACK FOOTER //
// ./src/js/core-components/popover-select/PopoverSelectContainerDirective.js